angular
  .module('countriesApp')
  .service('FundingReportModel', [
    'RoutesService',
    'SlugAndIdService',
    function (Routes, SlugAndId) {
      /**
       * Extract the short name of every single donor
       *
       * @param {Array} donors - An array coming from the BE
       *
       * @returns {Array} - Either empty or filled with donor short names as string
       */
      const extractDonorNames = donors => donors.map(donor => donor.short_name);

      return class FundingReportModel {
        constructor(data) {
          this.id = data.id;
          this.title = data.title;
          this.slugAndId = SlugAndId.createSlugAndId(data.type, this.id);
          this.link = Routes.funding_search_path({ report: this.slugAndId });

          if (data.donors) {
            this.donors = extractDonorNames(data.donors);
          }

          switch(data.type) {
            case 'funding_info':
              this.discovery_date = data.discovery_date;
              break;
            case 'contract':
              this.updated_at = data.updated_at;
              break;
          }
        }
      };
    }
  ]);
